import { RouteRecordRaw } from 'vue-router';

import { useAccountSettingStore } from '@/store';

// パスワード関連
export const passwordRoutes: Array<RouteRecordRaw> = [
  {
    name: 'PasswordUpdate',
    component: () => import('@/components/pages/password/update/index.vue'),
    path: '/password/update',
    meta: {
      title: 'パスワード変更',
    },
    beforeEnter: async () => {
      await useAccountSettingStore()
        .getAccountSetting();
    },
  },
];
